//#region src/pinata_table_tracker_request_type.ts
var PinataTableTrackerRequestType = /* @__PURE__ */ function(PinataTableTrackerRequestType) {
	PinataTableTrackerRequestType["Jtech"] = "jtech";
	PinataTableTrackerRequestType["Lrs"] = "lrs";
	return PinataTableTrackerRequestType;
}(PinataTableTrackerRequestType || {});
//#endregion
export { PinataTableTrackerRequestType };

//# sourceMappingURL=pinata_table_tracker_request_type.js.map